import { LoadingButton } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { useContent } from "../../content/useContent";
import { Colors } from "../../theme/colors";

import FormikOtp from "../Form/FormikOtp";

const classes = {
  description: {
    lineHeight: "70px",
    fontSize: "32px",
    fontWeight: "700",
    color: Colors.white,
  },
  forgetPassword: {
    display: "inline-block",
    fontWeight: "700",
    color: Colors.white,
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
      textDecorationColor: Colors.white,
    },
  },
  disabled: {
    display: "inline-block",
    fontWeight: "700",
    color: Colors.white,
    opacity: 0.6,
    pointerEvents: "none",
  },
  btn: {
    height: "66px",
    width: "100%",
    fontWeight: "600",
    fontSize: "18px",
  },
  fieldContainer: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
  },
};

type IProps = {
  formik: any;
  loading: boolean;
  setShowResetEmail: React.Dispatch<React.SetStateAction<boolean>>;
  setShowOtp: React.Dispatch<React.SetStateAction<boolean>>;
  handleResentOtp: any;
  count: any;
};

const OtpForm: React.FC<IProps> = ({
  formik,
  loading,
  setShowResetEmail,
  setShowOtp,
  handleResentOtp,
  count,
}) => {
  const { login } = useContent().pages;

  return (
    <>
      <Box>
        <Typography
          variant="h1"
          component="h1"
          color="secondary"
          sx={classes.description}
        >
          {login.typeOtp}
        </Typography>
        <Box sx={classes.fieldContainer}>
          <FormikOtp formik={formik} name="otp" />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: "19px",
            mb: "7px",
          }}
        >
          <Typography
            onClick={() => {
              setShowResetEmail(true);
              setShowOtp(false);
            }}
            variant="body2"
            component="span"
            color="secondary"
            sx={classes.forgetPassword}
          >
            {login.changeEmail}
          </Typography>
          <Typography
            onClick={() => {
              setShowResetEmail(false);
              setShowOtp(false);
            }}
            variant="body2"
            component="span"
            color="secondary"
            sx={classes.forgetPassword}
          >
            {login.log}
          </Typography>
        </Box>
      </Box>

      <LoadingButton
        variant="contained"
        color="secondary"
        onClick={formik.handleSubmit}
        loading={loading}
        sx={classes.btn}
      >
        {login.send}
      </LoadingButton>
      <Box sx={{ mt: "12px" }}>
        {count > 0 && (
          <Typography
            variant="body2"
            color="secondary"
            sx={{
              fontWeight: "bold",
              mb: "6px",
              color: Colors.white,
            }}
          >
            {count}
          </Typography>
        )}
        <Typography
          variant="body2"
          color="secondary"
          sx={{ fontWeight: "bold", fontSize: "14px" }}
        >
          {login.didntOtp}{" "}
          <Typography
            onClick={() => handleResentOtp(count)}
            variant="body2"
            component="span"
            color="secondary"
            sx={
              count > 0 || loading ? classes.disabled : classes.forgetPassword
            }
          >
            {login.resend}
          </Typography>
        </Typography>
      </Box>
    </>
  );
};

export default OtpForm;
